module.exports = __webpack_public_path__ + "img/chevron-left.154c5d68.svg";